import type React from 'react';

import type { IconProps } from 'types/icon';

const ChevronRight: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M8.5877 5.58712C8.83724 5.33758 9.24167 5.33758 9.49121 5.58712L16.1832 12.2785L9.4918 18.9764C9.24237 19.226 8.83736 19.2264 8.5877 18.977C8.33816 18.7276 8.33794 18.3231 8.58711 18.0735L14.3756 12.2791L8.5877 6.49064C8.33815 6.24109 8.33815 5.83667 8.5877 5.58712Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronRight;
